export default __webpack_public_path__ + "static/media/outdoor.5213c143.jpg";